/**
 * @fileOverview TSA服务商的一些公用StoreageKey
 * @author kirkzheng
 */

import tsaPath from "./tsaPath.js"

/**
 * @description 相关的storageKey
 * @property {string} sideNav - 导航的
 * @property {string} uname - 用户名
 * @property {string} loguid - loguid
 * @property {string} agid - agid
 * @property {string} notice - 通知
 * @property {string} guideIndex - 首页引导
 * @property {string} guideFinance - 财务引导
 * @property {string} guideRole - 角色引导
 */
export default {
  sideNav: tsaPath._dirname + "_sidenavdata",
  uname: tsaPath._dirname + "_uname",
  loguid: tsaPath._dirname + "_loguid",
  agid: tsaPath._dirname + "_agid",
  notice: tsaPath._dirname + "_notice",
  completeInfomationNotice: tsaPath._dirname + "_completeinfomationnoticev2",
  guideIndex: tsaPath._dirname + "_guide_index",
  guideFinance: tsaPath._dirname + "_finance_index",
  guideRole: tsaPath._dirname + "_role_index",
  userQQName: tsaPath._dirname + "_userQQName",
}
